import React, { Component } from 'react';
import '../styles/Header.css';

export default class Header extends Component {
    constructor(props) {
        super(props);

        this.state = {
            current: this.props.current,
            logged: false
        }
    }

    render() {
            return (
                <div>
                    {/* <!-- ==========Preloader========== --> */}
                    <div className="preloader">
                        <div className="preloader-inner">
                            <div className="preloader-icon">
                                <span></span>
                                <span></span>
                            </div>
                        </div>
                    </div>
                    {/* <!-- ==========Preloader========== --> */}
                    {/* <!-- ==========Overlay========== --> */}
                    <div className="overlay"></div>
                    <a href="#0" className="scrollToTop">
                        <i className="fas fa-angle-up"></i>
                    </a>
                    {/* <!-- ==========Overlay========== --> */}
                    {/* <!-- ==========Header-Section========== --> */}
                    <header className="header-section">
                        <div className="container" style={{maxWidth: "100%"}}>
                            <div className="header-wrapper">
                                <div className="logo">
                                    <a href="/">
                                        <img src="/assets/images/logo/logo.png" alt="Mis Tickets" />
                                    </a>
                                </div>
                                <ul className="menu">
                                    <li>
                                        <a href="/#eventos">Eventos</a>
                                    </li>
                                </ul>
                                <ul className="social-icons">
                                    <li>
                                        <a href="https://www.facebook.com/MisTickets" target="_blank" rel="noreferrer">
                                            <i className="fab fa-facebook-f"></i>
                                        </a>
                                    </li>
                                    {/* <li>
                                        <a href="#0" target="_blank" rel="noreferrer">
                                            <i className="fab fa-twitter"></i>
                                        </a>
                                    </li>
                                    <li>
                                        <a href="#0" target="_blank" rel="noreferrer">
                                            <i className="fab fa-pinterest-p"></i>
                                        </a>
                                    </li>
                                    <li>
                                        <a href="#0" target="_blank" rel="noreferrer">
                                            <i className="fab fa-google"></i>
                                        </a>
                                    </li> */}
                                    <li>
                                        <a href="https://www.instagram.com/mistickets/" target="_blank" rel="noreferrer">
                                            <i className="fab fa-instagram"></i>
                                        </a>
                                    </li>
                                </ul>
                                <div className="header-bar d-lg-none">
                                    <span></span>
                                    <span></span>
                                    <span></span>
                                </div>
                            </div>
                        </div>
                    </header>
                    {/* <!-- ==========Header-Section========== --> */}
                </div>
            );
    }
}